<template>
  <div
    class="container-fluid promotion-page p-2 pt-3"
    style="scrollbar-width: none; -ms-overflow-style: none; height: 100vh; overflow-y: scroll; background-size: cover; padding-bottom: 15rem; background-attachment: fixed;"
  >
    <div style="height: 130vh;">
      <!-- <div class="my-3 d-flex flex-wrap px-0 mx-0">
            <button class="detail-button w-auto text-nowrap mx-1 my-1">ALL</button>
            <button class="detail-button w-auto text-nowrap my-1">NEW MEMBER</button>
            <button class="detail-button w-auto text-nowrap mx-1 my-1">LIVE CASINO</button>
            <button class="detail-button w-auto text-nowrap my-1">LIVE CASINO</button>
            <button class="detail-button w-auto text-nowrap mx-1 my-1">LIVE CASINO</button>
            <button class="detail-button w-auto text-nowrap my-1">LIVE CASINO</button>
          </div> -->
      <div class="col-12 px-1 mb-5 pb-5">
        <div
          class="card bg-transparent mt-2"
          style="box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; box-shadow: none;"
          v-for="(promotion, proIndex) in promotions"
          :key="proIndex"
        >
          <a href="#">
            <!-- https://t.me/hulk333vip -->
            <img
              :src="promotion.image"
              style="border-radius: 5px; width: 100%;"
              alt=""
            >
          </a>
          <div class="px-3 py-2 d-flex justify-content-between bg-transparent">
            <h3 class="text-dark my-auto">
              <!-- <picture class="mr-2">
                      <source srcset="https://fonts.gstatic.com/s/e/notoemoji/latest/1f4b8/512.webp" type="image/webp">
                      <img src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f4b8/512.gif" alt="💸" width="25" height="25">
                    </picture> -->
              {{ promotion.title }}
              <!-- <picture class="ml-2">
                      <source srcset="https://fonts.gstatic.com/s/e/notoemoji/latest/1f4b8/512.webp" type="image/webp">
                      <img src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f4b8/512.gif" alt="💸" width="25" height="25">
                    </picture> -->
            </h3>
            <button
              class="detail-button col-3"
              @click=" promotionIndex(proIndex)"
            >{{ $t('detail') }}</button>
          </div>

          <van-overlay
            :show="selectedPromotion === proIndex"
            @click="selectedPromotion = null"
          >
            <div class="wrapper col-12 d-flex h-100vh">
              <div
                class="col-11 card mx-auto my-auto py-4 px-3"
                style="background: #202124 !important;"
              >
                <h2
                  class="pb-3"
                  style="color: #d3d3d3"
                > {{ promotion.title }}</h2>
                <span
                  style="color: #B7AAAA"
                  v-html="promotion.description"
                ></span>
              </div>
            </div>
          </van-overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      // websiteInfo: [],
      isLoading: false,
      selectedPromotion: null,
      promotions: [
        // {
        //   title: 'မိတ်ဆက်ဘောနပ်စ်',
        //   description: `📌 သူငယ်ချင်းအားမိတ်ဆက်ပေးပြီး 𝐅𝐫𝐞𝐞  𝟓,𝟎𝟎𝟎 ရယူနိုင်ပါသည်။ <br><br>
        //                 📌 သင်မိတ်ဆက်ပေးသောသူငယ်ချင်း၏ပထမဆုံး သွင်းငွေမှာ အနည်းဆုံးကျပ် 𝟏𝟎,𝟎𝟎𝟎 ဖြစ်ရပါမည်။ <br><br>
        //                 📌 ရရှိသောဘောနပ်စ်သည် နိုင်ငွေ 𝟐 ဆ ပြည့်မှသာငွေထုတ်နိုင်မည်။ <br><br>
        //                 📌 𝐒𝐋𝐎𝐓 အတွက် 𝐅𝐫𝐞𝐞 𝐬𝐩𝐢𝐧 မဝယ်ရ ၊ စစ်ဆေးတွေ့ရှိပါကငွေထုတ်ပေးမည်မဟုတ်ပါ။ <br><br>
        //                 📌 အမြင့်ဆုံးထုတ်ယူနိုင်သည့် ပမာဏသည် 𝟏𝟎,𝟎𝟎𝟎 ဖြစ်ပြီး ကျန်ယူနစ်များအား 𝐬𝐞𝐫𝐯𝐞𝐫 မှ 𝐚𝐮𝐭𝐨 နုတ်ယူသွားမည်ဖြစ်သည်။" <br><br>
        //                 ❌❌❌ 𝐒𝐋𝐎𝐓 အတွက် 𝐅𝐫𝐞𝐞 𝐬𝐩𝐢𝐧 မဝယ်ရ ၊ စစ်ဆေးတွေ့ရှိပါကငွေထုတ်ပေးမည်မဟုတ်ပါ။ <br><br>`,
        //   image: 'https://storage.googleapis.com/spacetech2/spin888/cards/BN50.webp',
        // },

        {
          title: ' မန်ဘာသစ် 200% Bonus',
          description: `❤️မန်ဘာသစ်ဘောနပ် 200% <br><br>
❤️ 5,000 သွင်း 10,000 ဘောနပ်ရပါတယ်
ပထမဆုံးငွေသွင်းဘောနပ် 200% ရဲ့ စည်းကမ်းချက်လေးကတော့ ဘောနပ်+သွင်းငွေ ၁၀ဆပြည့်တာနဲ့ ထုတ်ပေးပါတယ် (သွင်းငွေ 5,000+10,000=15,000*10=150,0000)<br><br>
❤️ အများဆုံး ထုတ်နိုင်ငွေ  - 100,000  ကျပ်<br><br>
သတ်မှတ် ပမာဏထက် ပိုသော အမှတ်များကို ဆာဗာမှ အော်တိုဖျက်သိမ်းမည်ဖြစ်သည်။ <br><br>`,
          image: 'https://storage.googleapis.com/spacetech2/kob/banners/promo7.avif',
        },
        {
          title: 'နေ့စဉ်ငွေသွင်း 30% Bonus',
          description: `❤️ နေ့စဉ် (30%ဘောနပ်)<br><br>
5,000 သွင်း 1,500 ဘောနပ်<br><br>
10,000 သွင်း 3,000 ဘောနပ်<br><br>
20,000 သွင်း 6,000 ဘောနပ်<br><br>

ဘောနပ်+သွင်းငွေ ၁၀ဆ ပြည့်တာနဲ့ သွင်းငွေ၏ ၆ဆ ထုတ်နိုင်။
(ကျန်သောယူနစ်များကို ဆာဗာမှသိမ်းဆည်းသွားပါမည်)<br><br>

နေ့စဉ်ဘောနပ်ကို တစ်နေ့(၁)ကြိမ်သာ ရယူနိုင်ပါသည်။ <br><br>`,
          image: 'https://storage.googleapis.com/spacetech2/kob/banners/promo6.avif',
        },
        // {
        //   title: 'နေ့စဉ်ဘောနပ်စ် 20% (တစ်နေ့တစ်ကြိမ်)',
        //   description: `📌 အနည်းဆုံး 𝟑,𝟎𝟎𝟎 ကစသွင်းပါကဒီပရိုမိုးရှင်းရနိုင်ပါသည်။ <br><br>
        //                 📌 အမြင့်ဆုံးရယူနိုင်သည့် 𝐁𝐨𝐧𝐮𝐬 မှာ ငွေကျပ် 60,000 ဖြစ်ပါသည်။ <br><br>
        //                 📌 နိုင်ငွေ 3 ဆ ပြည့်မှသာ ငွေထုတ်ပေးပါမည်။ <br><br>
        //                 📌 နိုင်ငွေ ပြည့်ပြီးပါက ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည်။ <br><br>
        //                 ✅✅✅ ဤပရိုမိုးရှင်းသည် ရှမ်းကိုးမီး နှင့် ဘူကြီး ကစားနိုင်ပါသည်။`,
        //   image: 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/banners/banner_4.jpg',
        // },
        // {
        //   title: 'SLOT သီးသန့်ပရိုမိုးရှင်း 20% (တစ်နေ့တစ်ကြိမ်)',
        //   description: `📌 အနည်းဆုံးကျပ် 3,000 စသွင်းပါက ဒီပရိုမိုးရှင်းကိုရယူနိုင်ပါသည်။ <br><br>
        //                 📌 အမြင့်ဆုံးရယူနိုင်သည့် Bonus မှာ ငွေကျပ် 60,000 ဖြစ်ပါသည်။ <br><br>
        //                 📌 နိုင်ငွေ 3ဆ ပြည့်မှသာ ငွေထုတ်ပေးပါမည် <br><br>
        //                 📌 နိုင်ငွေ ပြည့်ပြီးပါက ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည်။ <br><br>
        //                 ✅✅✅ ဤပရိုမိုးရှင်းသည် စလော့များကိုသာ ကစားနိုင်ပါသည်။
        //                 `,
        //   image: 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/banners/banner_5.jpg',
        // },
        //         {
        //           title: 'ရှူံးကြေးပြန်အမ်းငွေဘောနပ်စ် 10%',
        //           description: `🔮 ဤပရိုမိုးရှင်းသည် KOB88 ၏ မန်ဘာဝင်တိုင်း ရယူနိုင်ပါသည်။ <br><br>
        // 🔮 တစ်ရက်အတွင်း ရှုးထားသောငွေ၏ 𝟏𝟎% ကိုပြန်ရယူနိုင်ပါသည်။ <br><br>
        // 🔮 ရှုးကြေးကို ည 𝟎𝟑:𝟎𝟎 နာရီနောက်ပိုင်းတွင် 𝐬𝐲𝐬𝐭𝐞𝐦 မှ 𝐚𝐮𝐭𝐨 ပြန်အမ်းပေးပါမည်။ <br><br>
        // 🔮 နိုင်ငွေ 𝟏 ဆ ပြည့်မှသာငွေထုတ်ယူနိုင်မည်။ <br><br>
        // 🔮 နိုင်ငွေ ပြည့်ပြီးပါက ကန့်သတ်ချက်မရှိ ငွေထုတ်ယူနိုင်ပါသည်။ <br><br>`,
        //           image: 'https://storage.googleapis.com/spacetech2/kob/banners/CB10.avif',
        //         },
        {
          title: 'VIP မန်ဘာများအတွက် 100% Bonus',
          description: `🥰 ကြိမ်နှုန်း ၁၀ဆ နဲ့ သွင်းငွေ၏ ၅ဆ ထုတ်ယူနိုင်ပါတယ်။ <br><br>ဤပရိုမိုးရှင်းကို မန်ဘာတိုင်း တစ်ရက် တစ်ကြိမ် ရယူနိုင်ပါသည်။ <br><br>
          သတ်မှတ် ပမာဏထက် ပိုသော အမှတ်များကို ဆာဗာမှ အော်တိုဖျက်သိမ်းမည် ဖြစ်သည်။🥰 <br><br>`,
          image: 'https://storage.googleapis.com/spacetech2/kob/banners/promo5.avif',
        },
        {
          title: ' SAT & SUN 50% Bonus',
          description: `❤️ ကြိမ်နှုန်း ၁၀ဆနဲ့ သွင်းငွေ၏ ၅ဆ ထုတ်ယူနိုင်ပါတယ်။ <br><br>သတ်မှတ်ပမာဏထက် ပိုသော အမှတ်များကို ဆာဗာမှ အော်တိုဖျက်သိမ်းမည်ဖြစ်သည်။ <br><br>ဤပရိုမိုးရှင်းကို မန်ဘာတိုင်း တစ်ရက် တစ်ကြိမ် ရယူနိုင်ပါသည်။ ❤️ <br><br>`,
          image: 'https://storage.googleapis.com/spacetech2/kob/banners/promo4.avif',
        },
        {
          title: 'ရှုံးကြေး 10% Bonus ',
          description: `❤️ ကြိမ်နှုန်း၂၀ဆ ပြည့်အောင်ဆော့ပြီးမှ အများဆုံး(သွင်းငွေရဲ့ ၃ဆ) ထုတ်ယူနိုင်ပါတယ်။<br><br> သတ်မှတ်ပမာဏထက် ပိုသော အမှတ်များကို ဆာဗာမှ အော်တိုဖျက်သိမ်းမည်ဖြစ်သည်။️<br><br> ဤပရိုမိုးရှင်းကို မန်ဘာတိုင်း တစ်ရက် တစ်ကြိမ် ရယူနိုင်ပါသည်။ ❤️<br><br>`,
          image: 'https://storage.googleapis.com/spacetech2/kob/banners/promo1.avif',
        },
        {
          title: ' သူငယ်ချင်းမိတ်ဆက် 10% Bonus',
          description: `🫶 မိတ်ဆက်ခံရသူ၏ ပထမဆုံး ငွေသွင်းပမာဏ၏ 10% ကို တွက်ချက်ပေးမည် ဖြစ်သည်။ 🥰<br><br>
🫶 ရရှိသော မိတ်ဆက်ဘောနပ်ကို ကြိမ်ရေ  5ဆ ကစားပြီး အများဆုံး ဘောနပ်ပမာဏ၏ 3 ဆ ထုတ်ယူနိုင်ပါသည်။ 🥰<br><br>
🫶 အနည်းဆုံး 1,000 ကျပ်မှ စတင်ရယူနိုင်သည်။ 🥰<br><br>
🫶 ဂိမ်းအားလုံးကစားနိုင်သည်။ 🥰 <br><br>`,
          image: 'https://storage.googleapis.com/spacetech2/kob/banners/promo3.avif',
        },
        {
          title: 'Lucky Friday 99.99%',
          description: `ကြိမ်နှုန်း 5ဆ နှင့် ဘောနပ်၏ 3ဆ ထုတ်ယူနိုင်ပါသည်။<br><br>
သတ်မှတ်ပမာဏထက် ပိုသော အမှတ်များကို ဆာဗာမှ အော်တိုဖျက်သိမ်းမည်ဖြစ်သည်။️<br><br>
ဤပရိုမိုးရှင်းကို မန်ဘာတိုင်းရယူနိုင်သည်။ <br><br>`,
          image: 'https://storage.googleapis.com/spacetech2/kob/banners/promo2.avif',
        },
      ]
    };
  },
  methods: {
    promotionIndex(index) {
      this.selectedPromotion = index;
    },
    // async fetchWebsiteData() {
    //   try {
    //     const res = await axios.get('/website-infos');
    //     this.websiteInfo = res.data.data[0];
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
  },
  async mounted() {
    // this.$store.commit('setLoading', true);
    // await this.fetchWebsiteData();
    // this.$store.commit('setLoading', false);
  },
};
</script>
<style scoped>
.promotion-page {
  background: linear-gradient(180deg, #fef3c7 0%, #fffbeb 22%, #ffffff 55%, #fffbeb 100%);
}

.detail-button {
  appearance: none;
  background-color: transparent;
  border: 1px solid #92400e;
  text-transform: uppercase;
  border-radius: 14px;
  box-sizing: border-box;
  color: #0c0a09;
  cursor: pointer;
  display: inline-block;
  font-family: Roobert, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 0.9rem;
  font-weight: 450;
  line-height: normal;
  margin: 0;
  min-height: 15px;
  min-width: 0;
  outline: none;
  padding: 1px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 100%;
  will-change: transform;
}

.detail-button:disabled {
  pointer-events: none;
}

.detail-button:hover {
  color: #fff;
  background: linear-gradient(135deg, #92400e 0%, #92400e 50%, #ca8a04 100%);
  border-color: #92400e;
  transform: translateY(-2px);
}

.detail-button:active {
  box-shadow: none;
  transform: translateY(0);
  background: linear-gradient(135deg, #0c0a09 0%, #92400e 100%);
  border-color: #0c0a09;
}

.animate-charcter {
  text-transform: uppercase;
  background-image: linear-gradient(-225deg,
      #b45309 0%,
      #f3e706 29%,
      #b45309 67%,
      #f3e706 100%);
  background-size: auto auto;
  background-clip: border-box;
  background-size: 200% auto;
  color: #fff;
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: textclip 2s linear infinite;
  display: inline-block;
  /* font-size: 190px; */
}

@keyframes textclip {
  to {
    background-position: 200% center;
  }
}
</style>